import { Controller } from "@hotwired/stimulus"
import { marked } from "marked"

export default class extends Controller {
  static targets = ["editor", "preview", "wordCount"]

  connect() {
    this.r2BaseUrl = document.querySelector('meta[name="r2-base-url"]')?.content || ""
    this.updatePreview()
  }

  updatePreview() {
    const markdown = this.editorTarget.value

    // Strip frontmatter for preview
    let body = markdown.replace(/^---[\s\S]*?---\s*/, '')

    // Strip MDX import statements
    body = body.replace(/^import\s+.*from\s+['"].*['"];?\s*$/gm, '')

    // Convert MDX components to HTML for preview
    body = this.convertImageGalleries(body)
    body = this.convertMapEmbeds(body)

    // Render markdown to HTML
    this.previewTarget.innerHTML = marked.parse(body, {
      breaks: true,
      gfm: true
    })

    // Update word count
    const words = body.split(/\s+/).filter(w => w.length > 0).length
    if (this.hasWordCountTarget) {
      this.wordCountTarget.textContent = `${words} words`
    }
  }

  convertMapEmbeds(text) {
    const mapRegex = /<MapEmbed\s+src="([^"]+)"(?:\s+title="([^"]*)")?\s*\/>/g
    return text.replace(mapRegex, (match, src, title) => {
      return `<div style="margin:2rem 0;"><iframe src="${src}" title="${title || 'Map'}" width="100%" height="480" style="border:0;border-radius:12px;" loading="lazy" allowfullscreen></iframe></div>`
    })
  }

  convertImageGalleries(text) {
    // Match <ImageGallery ... /> components (single or multi-line)
    const galleryRegex = /<ImageGallery\s+columns=\{(\d+)\}\s+images=\{\[([\s\S]*?)\]\}\s*\/>/g

    return text.replace(galleryRegex, (match, columns, imagesStr) => {
      // Parse image objects from the JSX-like syntax
      const imageRegex = /\{\s*image:\s*"([^"]+)",\s*alt:\s*"([^"]*)"\s*\}/g
      const images = []
      let m
      while ((m = imageRegex.exec(imagesStr)) !== null) {
        images.push({ image: m[1], alt: m[2] })
      }

      if (images.length === 0) return match

      const baseUrl = this.r2BaseUrl
      const imgTags = images.map(img => {
        const url = img.image.startsWith("http") ? img.image : `${baseUrl}/${img.image}`
        return `<div><img src="${url}" alt="${img.alt}" style="width:100%;border-radius:8px;"></div>`
      }).join("")

      return `<div style="display:grid;grid-template-columns:repeat(${columns},1fr);gap:0.75rem;margin:1rem 0;">${imgTags}</div>`
    })
  }
}
